module.exports = __webpack_public_path__ + "img/humidity-ac.d613f889.png";